<script setup lang="ts">
  import { Message } from "@/ui";
  import Button from "primevue/button";
  import InputText from "primevue/inputtext";
  import { useField, useFieldArray, useFormContext } from "vee-validate";

  const props = withDefaults(
    defineProps<{
      removeable: boolean;
      idx: number;
    }>(),
    {
      removeable: true,
    },
  );

  const emit = defineEmits(["remove"]);
  const { errors, submitCount } = useFormContext();
  const { fields: products, push, remove } = useFieldArray<string>(() => `services[${props.idx}].products`);
  const { value: service, errorMessage: serviceError } = useField<string>(() => `services[${props.idx}].service`);
</script>

<template>
  <div class="p-4 bg-gray-50 rounded-md w-sm flex flex-col gap-4">
    <div class="mb-3 w-full">
      <label class="block text-sm mb-1">Dienst</label>
      <div class="flex flex-row gap-2 w-full">
        <div class="flex flex-col gap-1 w-full">
          <InputText v-model="service" class="w-full" required :invalid="!!serviceError" />
          <Message v-if="serviceError" severity="error" size="small" variant="simple" :text="serviceError" />
        </div>
        <Button icon="pi pi-trash text-red-500" severity="secondary" rounded text @click="emit('remove')" :disabled="!removeable" />
      </div>
    </div>

    <div v-for="(field, idx) in products" :key="field.key" class="mb-3 ml-5">
      <label class="block text-sm mb-1">Product</label>
      <div class="flex flex-row gap-2">
        <div class="flex flex-col gap-1 w-full">
          <InputText v-model="field.value" class="w-full" required :invalid="!!errors?.[`services[${props.idx}].products[${idx}]`] && !!submitCount" />
          <Message
            v-if="errors?.[`services[${props.idx}].products[${idx}]`] && !!submitCount"
            severity="error"
            size="small"
            variant="simple"
            :text="errors?.[`services[${props.idx}].products[${idx}]`]"
          />
        </div>
        <Button icon="pi pi-trash text-red-500" severity="secondary" rounded text @click="remove(idx)" />
      </div>
    </div>

    <Button class="!w-[fit-content]" icon="pi pi-plus" label="Product" text @click="push('')" />
  </div>
</template>
